import { FC } from "react";
import { TAlertBodyProps } from "./Alert.config";
import { cn } from "@/ui/lib";
import { getAlertCopyColumnClass } from "./Alert.utils";
import { TextBody } from "../../typography/TextBody";

export const AlertBody: FC<TAlertBodyProps> = ({ children, asset, hasTitle }) => (
  <div
    data-component="AlertBody"
    className={cn(
      hasTitle ? "row-start-2" : "row-start-1",
      getAlertCopyColumnClass(asset),
      "text-foreground-muted-strong",
    )}
  >
    <TextBody
      tag="p"
      size={2}
      isResponsive={false}
      className="mb-0"
      color="inherit"
    >
      { children }
    </TextBody>
  </div>
);
